<template lang="pug">
  SearchConditions(:initSearchCond="initSearchCond" @onChangeSearchConditions="onChangeSearchConditions")
    template(v-slot:conditions="{ conditions }")
      v-layout(wrap)
        v-flex(md2)
          v-text-field(label="荷主" v-model="conditions.clientName")
        v-flex(md2)
          v-text-field(label="荷主枝番" v-model="conditions.clientBranchName")
        v-flex(md2)
          v-text-field(label="積地" v-model="conditions.loadingPlace")
        v-flex(md2)
          v-text-field(label="卸地" v-model="conditions.unloadingPlace")
        v-flex(md2)
          v-text-field(label="請求区分" v-model="conditions.billingTypeName")
        v-flex(md2)
          DistanceTypeSelect(:code.sync="conditions.distanceType" :clearable="true")
      v-layout(wrap)
        v-flex(md2)
          v-text-field(label="PB No" v-model="conditions.planBoardNo")
        v-flex(md2)
          v-text-field(label="ルートNo" v-model="conditions.routeNo")
        v-flex(md2)
          v-text-field(label="伝票番号" v-model="conditions.slipNo")
        v-flex(md2)
          v-text-field(label="シップメントNo/受付番号" v-model="conditions.shipmentNo")
        v-flex(md4)
          v-layout(wrap)
            v-flex(md4)
              DatePicker(:pickerLabel="labelName.LoadingSchedule" :initDate="conditions.loadingDate" :inputDate.sync="conditions.loadingDate")
            v-flex(md4)
              DatePicker(:pickerLabel="labelName.UnloadingSchedule" initDate="" :inputDate.sync="conditions.unloadingDate" :isClearable="true")
            v-flex(md4)
              DatePicker(pickerLabel="受注日" initDate="" :inputDate.sync="conditions.orderDate" :isClearable="true")
        v-flex(md2)
          DispatchStatusSelect(:code.sync="conditions.dispatchStatusList" :clearable="true")

        v-flex(md4)
          v-layout(wrap)
            v-flex(md6)
              DatePicker(pickerLabel="作成日" initDate="" :inputDate.sync="conditions.createdDate" :isClearable="true")
            v-flex(md6)
              TimePicker(pickerLabel="作成時間" initTime="" :inputTime.sync="conditions.createdTime"
                :error-handler-method="()=>{}" :allowedMinutes="1")
        v-flex(md2)
          v-text-field(label="作成者" v-model="conditions.createdUser")
</template>

<script>
import SearchConditions from "@/components/common/search/SearchConditions";
import DatePicker from "@/components/common/DatePicker";
import TimeSecondPicker from "@/components/common/TimeSecondPicker";
import DistanceTypeSelect from "@/components/common/select/DistanceTypeSelect";
import DispatchStatusSelect from "@/components/common/select/DispatchStatusSelect";
import { LabelName } from "@/assets/js/constants";
import TimePicker from "@/components/common/TimePicker.vue";

export default {
  components: {
    TimePicker,
    SearchConditions,
    DatePicker,
    TimeSecondPicker,
    DistanceTypeSelect,
    DispatchStatusSelect
  },
  data: () => ({
    labelName: LabelName
  }),
  methods: {
    onChangeSearchConditions(item) {
      this.$emit("onChangeSearchConditions", item);
    },
    initSearchCond() {
      return {
        conditions: {
          clientName: "",
          clientBranchName: "",
          loadingDate: window.Common.Util.getTomorrowYearMonthDayIsoFormat(),
          loadingPlace: "",
          unloadingDate: "",
          unloadingPlace: "",
          orderDate: "",
          billingTypeName: "",
          distanceType: "",
          planBoardNo: "",
          routeNo: "",
          slipNo: "",
          shipmentNo: "",
          dispatchStatusList: [],
          createdDate: "",
          createdTime: "",
          createdUser: ""
        }
      };
    }
  }
};
</script>
